import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[DisableOnClick]'
})
export class DisableOnClickDirective {

  constructor(private el: ElementRef) {}

  @HostListener('click')
  async handleClick() {
    const button = this.el.nativeElement as HTMLButtonElement;
    button.disabled = true;

    setTimeout(() => {
      button.disabled = false;
    }, 1000);
  }
}
